import { Component, OnInit } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { AuthService } from '../auth-module/services/auth.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {
  showLoader;
  color: ThemePalette = 'primary';
  constructor(private authService: AuthService) {
    // this.authService.showLoader.subscribe((response)=>{    //Even calling admin APIs, but changing the showloader variable of auth Service in interceptor.
    //   console.log(response);
    //   this.showLoader = response;
    // })
  }

  ngOnInit(): void {
  }

}
